// extracted by mini-css-extract-plugin
export default {"my-jobs":"MyJobs_my-jobs__TCCt7","create-job":"MyJobs_create-job__79aHN"};